const CalenderIcon = () => (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 5.25V10.5C1.75 11.7887 2.79467 12.8333 4.08333 12.8333H9.91667C11.2053 12.8333 12.25 11.7887 12.25 10.5V5.25M1.75 5.25V4.375C1.75 3.08633 2.79467 2.04166 4.08333 2.04166H9.91667C11.2053 2.04166 12.25 3.08633 12.25 4.375V5.25M1.75 5.25H12.25M9.33333 1.16666V2.91666M4.66667 1.16666V2.91666"
        stroke="#005FEA"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </svg>
  );
  
  const ShareIcon = () => (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2929 7.31609C13.6834 6.92556 13.6834 6.2924 13.2929 5.90187L9.18953 1.79851C8.55957 1.16855 7.48243 1.61472 7.48243 2.50562V4.36119C5.52981 4.46356 3.70858 5.27275 2.31561 6.66572C0.822363 8.15893 0 10.1443 0 12.2561C0 12.6943 0.584069 12.844 0.794856 12.4598C2.035 10.1993 4.40896 8.795 6.99021 8.795C7.15389 8.795 7.31845 8.8008 7.48243 8.81229V10.7123C7.48243 11.6032 8.55957 12.0494 9.18953 11.4194L13.2929 7.31609ZM6.99021 7.9479C4.67849 7.9479 2.51511 8.95393 1.03094 10.6518C1.75921 7.52976 4.56529 5.19717 7.90595 5.19717H8.32948V2.13639L12.802 6.60895L8.32948 11.0815V8.05358L7.95802 8.00756C7.6384 7.96799 7.31279 7.9479 6.99021 7.9479Z"
        fill="#AAB3C1"
      />
    </svg>
  );
  
  const FavoriteIcon = () => (
    <svg
      width={12}
      height={13}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33325 4.08333H10.6666M1.33325 2.33333V10.5C1.33325 11.4614 2.43081 12.0102 3.19992 11.4333L5.29992 9.85833C5.71473 9.54722 6.2851 9.54722 6.69992 9.85833L8.79992 11.4333C9.56903 12.0102 10.6666 11.4614 10.6666 10.5V2.33333C10.6666 1.689 10.1443 1.16666 9.49992 1.16666H2.49992C1.85559 1.16666 1.33325 1.689 1.33325 2.33333Z"
        stroke="#AAB3C1"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  
  const ScreenIcon = () => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 14.275C7.95027 14.275 7.90258 14.2552 7.86742 14.2201C7.83225 14.1849 7.8125 14.1372 7.8125 14.0875V11.7969C7.8125 11.7471 7.83225 11.6995 7.86742 11.6643C7.90258 11.6291 7.95027 11.6094 8 11.6094C8.04973 11.6094 8.09742 11.6291 8.13258 11.6643C8.16775 11.6995 8.1875 11.7471 8.1875 11.7969V14.0875C8.1875 14.1372 8.16775 14.1849 8.13258 14.2201C8.09742 14.2552 8.04973 14.275 8 14.275Z"
        fill="#74839C"
      />
      <path
        d="M14.0754 0.5H1.92477C1.71143 0.504178 1.50823 0.591864 1.35883 0.744222C1.20942 0.89658 1.12573 1.10146 1.12573 1.31484C1.12573 1.52823 1.20942 1.73311 1.35883 1.88547C1.50823 2.03782 1.71143 2.12551 1.92477 2.12969H14.0754C14.2887 2.12551 14.4919 2.03782 14.6413 1.88547C14.7908 1.73311 14.8744 1.52823 14.8744 1.31484C14.8744 1.10146 14.7908 0.89658 14.6413 0.744222C14.4919 0.591864 14.2887 0.504178 14.0754 0.5Z"
        fill="#74839C"
      />
      <path
        d="M3.13853 11.6406H12.8616C13.2079 11.6403 13.5399 11.5026 13.7848 11.2578C14.0297 11.0129 14.1675 10.681 14.1679 10.3347V2.44218H1.83228V10.3347C1.83269 10.681 1.97045 11.0129 2.21534 11.2578C2.46023 11.5026 2.79224 11.6403 3.13853 11.6406Z"
        fill="#74839C"
      />
      <path
        d="M8.0002 15.6562C8.43339 15.6562 8.78457 15.3051 8.78457 14.8719C8.78457 14.4387 8.43339 14.0875 8.0002 14.0875C7.567 14.0875 7.21582 14.4387 7.21582 14.8719C7.21582 15.3051 7.567 15.6562 8.0002 15.6562Z"
        fill="#74839C"
      />
    </svg>
  );
  
  const ParkingIcon = () => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_252_360)">
        <path
          d="M12.4601 0H3.54029C1.58502 0 0 1.58466 0 3.54029V12.4597C0 14.4153 1.58466 16.0004 3.54029 16.0004H12.4601C14.4153 16.0004 16.0004 14.4153 16.0004 12.4597V3.54029C16 1.58502 14.4153 0 12.4601 0ZM10.3021 8.38232C9.6372 9.00959 8.6546 9.29074 7.50337 9.29074C7.24707 9.29074 7.01455 9.27867 6.84026 9.25204V11.7945C6.84026 12.1001 6.59247 12.3479 6.28683 12.3479H5.45119C5.14555 12.3479 4.89776 12.1005 4.89776 11.7945V4.3099C4.89776 4.02982 5.10685 3.79375 5.38481 3.76074C5.93575 3.69471 6.63578 3.65069 7.53639 3.65069C8.73837 3.65069 9.59744 3.88108 10.1725 4.34114C10.722 4.77671 11.0941 5.49237 11.0941 6.33653C11.0948 7.18033 10.814 7.89705 10.3021 8.38232Z"
          fill="#74839C"
        />
        <path
          d="M7.64402 5.12177C7.47825 5.12177 7.33625 5.12851 7.21626 5.1388C7.00292 5.15762 6.84033 5.33547 6.84033 5.54953V7.37771C6.84033 7.59851 7.01428 7.78027 7.23508 7.7895C7.31211 7.79269 7.3966 7.79411 7.49067 7.79411C8.52617 7.79411 9.16586 7.26944 9.16586 6.3873C9.16621 5.59461 8.61598 5.12177 7.64402 5.12177Z"
          fill="#74839C"
        />
      </g>
      <defs>
        <clipPath id="clip0_252_360">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  
  const AirIcon = () => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8.75C8.3 8.75 8.5 8.95 8.5 9.25V14.25C8.5 14.55 8.3 14.75 8 14.75C7.7 14.75 7.5 14.55 7.5 14.25V9.25C7.5 8.95 7.7 8.75 8 8.75ZM11 8.75C11.3 8.75 11.5 8.95 11.5 9.25C11.5 11.05 12.35 12.7 13.8 13.75C14 13.9 14.1 14.2 13.9 14.45C13.7 14.7 13.45 14.75 13.2 14.55C11.5 13.35 10.5 11.4 10.5 9.25C10.5 8.95 10.7 8.75 11 8.75ZM5 8.75C5.3 8.75 5.5 8.95 5.5 9.25C5.5 11.35 4.5 13.3 2.8 14.55C2.6 14.7 2.25 14.65 2.1 14.45C1.95 14.25 2 13.9 2.2 13.75C3.65 12.7 4.5 11.05 4.5 9.25C4.5 8.95 4.7 8.75 5 8.75ZM14 1.25C15.1 1.25 16 2.15 16 3.25V6.25C16 7.35 15.1 8.25 14 8.25H2C0.9 8.25 0 7.35 0 6.25V3.25C0 2.15 0.9 1.25 2 1.25H14ZM13.5 5.25H2.5C2.2 5.25 2 5.45 2 5.75C2 6.05 2.2 6.25 2.5 6.25H13.5C13.8 6.25 14 6.05 14 5.75C14 5.45 13.8 5.25 13.5 5.25Z"
        fill="#74839C"
      />
    </svg>
  );
  
  const ProjectIcon = () => (
    <svg
      width={16}
      height={10}
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0843 3.01357H14.1413C13.6283 1.58588 12.2609 0.562042 10.6588 0.562042C9.05669 0.562042 7.68927 1.58588 7.17618 3.01357H0.915712C0.410014 3.01357 0 3.42359 0 3.92929V7.25056C0 7.75633 0.410014 8.16642 0.915712 8.16642H15.0843C15.5899 8.16642 16 7.75633 16 7.25056V3.92929C16 3.42359 15.5899 3.01357 15.0843 3.01357ZM3.2625 6.8133H1.87901C1.6226 6.8133 1.4147 6.60536 1.4147 6.34899C1.4147 6.0925 1.6226 5.88464 1.87901 5.88464H3.26247C3.51892 5.88464 3.72678 6.0925 3.72678 6.34899C3.72681 6.6054 3.51892 6.8133 3.2625 6.8133ZM3.2625 5.28665H1.87901C1.6226 5.28665 1.4147 5.07875 1.4147 4.82238C1.4147 4.56592 1.6226 4.35807 1.87901 4.35807H3.26247C3.51892 4.35807 3.72678 4.56592 3.72678 4.82238C3.72681 5.07883 3.51892 5.28665 3.2625 5.28665ZM10.6588 6.72767C9.29889 6.72767 8.19258 5.62133 8.19258 4.26142C8.19258 2.90155 9.29889 1.79517 10.6588 1.79517C12.0187 1.79517 13.1251 2.90155 13.1251 4.26142C13.1251 5.62133 12.0187 6.72767 10.6588 6.72767Z"
        fill="#74839C"
      />
      <path
        d="M10.6654 2.72838C9.81419 2.72838 9.12402 3.41854 9.12402 4.26979C9.12402 5.12107 9.81419 5.81119 10.6654 5.81119C11.5167 5.81119 12.2068 5.12107 12.2068 4.26979C12.2068 3.41854 11.5166 2.72838 10.6654 2.72838ZM10.6654 3.83357C10.3143 3.83357 10.0296 3.65889 10.0296 3.4434C10.0296 3.22791 10.3143 3.05323 10.6654 3.05323C11.0166 3.05323 11.3013 3.22791 11.3013 3.4434C11.3013 3.65889 11.0165 3.83357 10.6654 3.83357Z"
        fill="#74839C"
      />
      <path
        d="M1.0979 9.03916C1.0979 9.25943 1.27647 9.438 1.49674 9.438H3.64458C3.86484 9.438 4.04341 9.25943 4.04341 9.03916V8.65042H1.0979V9.03916Z"
        fill="#74839C"
      />
      <path
        d="M11.9565 9.03916C11.9565 9.25943 12.1352 9.438 12.3555 9.438H14.5033C14.7235 9.438 14.9021 9.25943 14.9021 9.03916V8.65042H11.9565V9.03916Z"
        fill="#74839C"
      />
    </svg>
  );
  
  const BanquetsIcon = () => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_252_412)">
        <path
          d="M13.8472 13.25C13.8804 13.2744 13.9191 13.2902 13.9598 13.296C14.0005 13.3019 14.0421 13.2976 14.0808 13.2835C14.1347 13.2624 14.192 13.2511 14.25 13.25C14.3826 13.25 14.5098 13.3027 14.6036 13.3964C14.6973 13.4902 14.75 13.6174 14.75 13.75C14.75 13.8826 14.6973 14.0098 14.6036 14.1036C14.5098 14.1973 14.3826 14.25 14.25 14.25H11.75C11.6174 14.25 11.4902 14.1973 11.3964 14.1036C11.3027 14.0098 11.25 13.8826 11.25 13.75C11.25 13.6174 11.3027 13.4902 11.3964 13.3964C11.4902 13.3027 11.6174 13.25 11.75 13.25C11.8079 13.2507 11.8652 13.2616 11.9192 13.2823C11.9579 13.2963 11.9994 13.3006 12.0401 13.2948C12.0808 13.289 12.1195 13.2732 12.1526 13.2489C12.1858 13.2246 12.2124 13.1924 12.2302 13.1553C12.248 13.1182 12.2563 13.0773 12.2545 13.0363C12.2545 13.028 12.251 13.0077 12.25 13C12.2494 12.9015 12.2682 12.8039 12.3054 12.7126C12.3425 12.6214 12.3973 12.5384 12.4665 12.4684C12.6063 12.3269 12.7966 12.2467 12.9955 12.2455C13.1944 12.2443 13.3857 12.3222 13.5271 12.462C13.6686 12.6018 13.7488 12.7921 13.75 12.991C13.75 12.9987 13.7457 13.028 13.7455 13.0363C13.7435 13.0775 13.7517 13.1186 13.7695 13.1559C13.7872 13.1932 13.8139 13.2256 13.8472 13.25ZM4.25 12.25H6V13H4.9035C4.72336 12.8401 4.49084 12.7519 4.25 12.752V12.25ZM6.5 11.5C6.5 11.4506 6.51466 11.4022 6.54213 11.3611C6.5696 11.32 6.60865 11.288 6.65433 11.269C6.70001 11.2501 6.75028 11.2452 6.79877 11.2548C6.84727 11.2645 6.89181 11.2883 6.92678 11.3232C6.96174 11.3582 6.98555 11.4027 6.9952 11.4512C7.00484 11.4997 6.99989 11.55 6.98097 11.5957C6.96205 11.6414 6.93001 11.6804 6.88889 11.7079C6.84778 11.7353 6.79945 11.75 6.75 11.75C6.6837 11.75 6.62011 11.7237 6.57322 11.6768C6.52634 11.6299 6.5 11.5663 6.5 11.5ZM5.21425 13.5H6V14.25H5.111C5.17911 14.1389 5.22345 14.0149 5.24122 13.8858C5.25899 13.7567 5.24981 13.6254 5.21425 13.5ZM6.5 12.25H7V14.25H6.5V12.25ZM7.296 7.75H8.704C8.65309 7.89614 8.55796 8.02281 8.43181 8.11244C8.30567 8.20208 8.15475 8.25024 8 8.25024C7.84525 8.25024 7.69433 8.20208 7.56819 8.11244C7.44204 8.02281 7.34691 7.89614 7.296 7.75ZM11.0977 13H10V12.25H11.75V12.7522C11.5099 12.754 11.2785 12.8419 11.0977 13ZM9 11.5C9 11.4506 9.01466 11.4022 9.04213 11.3611C9.0696 11.32 9.10865 11.288 9.15433 11.269C9.20001 11.2501 9.25028 11.2452 9.29877 11.2548C9.34727 11.2645 9.39181 11.2883 9.42678 11.3232C9.46174 11.3582 9.48555 11.4027 9.4952 11.4512C9.50484 11.4997 9.49989 11.55 9.48097 11.5957C9.46205 11.6414 9.43 11.6804 9.38889 11.7079C9.34778 11.7353 9.29945 11.75 9.25 11.75C9.1837 11.75 9.12011 11.7237 9.07322 11.6768C9.02634 11.6299 9 11.5663 9 11.5ZM9 12.25H9.5V14.25H9V12.25ZM10 13.5H10.7858C10.7502 13.6254 10.741 13.7567 10.7588 13.8858C10.7766 14.0149 10.8209 14.1389 10.889 14.25H10V13.5ZM13.25 11.7775C13.0768 11.7399 12.8975 11.7408 12.7247 11.7801C12.5519 11.8195 12.3899 11.8962 12.25 12.005V8.75H13.25V11.7775ZM13.75 8.25H11.75V7.75H13.75V8.25ZM13.6858 6.25H11.4915C11.4543 5.38351 11.2191 4.53707 10.804 3.77558C10.3888 3.01408 9.80485 2.35778 9.09675 1.857C10.2028 2.07122 11.2237 2.59942 12.0375 3.37845C12.8513 4.15748 13.4235 5.15439 13.6858 6.25ZM8 1.784L8.27 1.9295C9.05803 2.35343 9.72286 2.97418 10.1998 3.73131C10.6767 4.48845 10.9495 5.35617 10.9915 6.25H5.0085C5.05054 5.35617 5.3233 4.48845 5.80022 3.73131C6.27714 2.97418 6.94197 2.35343 7.73 1.9295L8 1.784ZM7.5 1.25C7.5 1.11739 7.55268 0.990215 7.64645 0.896447C7.74021 0.802678 7.86739 0.75 8 0.75C8.13261 0.75 8.25979 0.802678 8.35355 0.896447C8.44732 0.990215 8.5 1.11739 8.5 1.25V1.27225C8.3345 1.259 8.16825 1.25 8 1.25C7.83175 1.25 7.6655 1.259 7.5 1.27225V1.25ZM6.90325 1.857C6.19515 2.35778 5.61115 3.01408 5.19604 3.77558C4.78093 4.53707 4.54574 5.38351 4.5085 6.25H2.31425C2.57651 5.15439 3.14874 4.15748 3.96253 3.37845C4.77632 2.59942 5.79724 2.07122 6.90325 1.857ZM1.75 6.75H14.25V7.25H1.75V6.75ZM4.25 7.75V8.25H2.25V7.75H4.25ZM2.75 8.75H3.75V12.005C3.61012 11.8962 3.44807 11.8195 3.27528 11.7801C3.10249 11.7408 2.92318 11.7399 2.75 11.7775V8.75ZM1.25 13.75C1.25 13.6174 1.30268 13.4902 1.39645 13.3964C1.49021 13.3027 1.61739 13.25 1.75 13.25C1.80788 13.2507 1.86518 13.2616 1.91925 13.2823C1.9579 13.2963 1.99942 13.3006 2.04013 13.2948C2.08084 13.289 2.11949 13.2732 2.15264 13.2489C2.1858 13.2246 2.21245 13.1924 2.23021 13.1553C2.24798 13.1182 2.25632 13.0773 2.2545 13.0363C2.25425 13.028 2.25 13.0077 2.25 13C2.24941 12.9015 2.26822 12.8039 2.30537 12.7126C2.34251 12.6214 2.39726 12.5384 2.46649 12.4684C2.6063 12.3269 2.79659 12.2467 2.9955 12.2455C3.19441 12.2443 3.38565 12.3222 3.52715 12.462C3.66864 12.6018 3.74881 12.7921 3.75 12.991C3.75 12.9987 3.74575 13.028 3.7455 13.0363C3.74368 13.0773 3.75202 13.1182 3.76979 13.1553C3.78755 13.1924 3.8142 13.2246 3.84736 13.2489C3.88051 13.2732 3.91916 13.289 3.95987 13.2948C4.00058 13.3006 4.0421 13.2963 4.08075 13.2823C4.13482 13.2616 4.19212 13.2507 4.25 13.25C4.38261 13.25 4.50979 13.3027 4.60355 13.3964C4.69732 13.4902 4.75 13.6174 4.75 13.75C4.75 13.8826 4.69732 14.0098 4.60355 14.1036C4.50979 14.1973 4.38261 14.25 4.25 14.25H1.75C1.61739 14.25 1.49021 14.1973 1.39645 14.1036C1.30268 14.0098 1.25 13.8826 1.25 13.75ZM15.25 15.25H0.75V14.75H15.25V15.25Z"
          fill="#74839C"
        />
      </g>
      <defs>
        <clipPath id="clip0_252_412">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  
  const PartyIcon = () => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_252_422)">
        <path
          d="M1.43506 10.5474L3.88178 15.2371L5.99101 14.3359L2.52843 7.98752L1.43506 10.5474Z"
          fill="#74839C"
        />
        <path
          d="M0.141029 13.5762C-0.34744 14.7193 0.492788 15.9995 1.74093 15.9995C1.97716 15.9995 2.20715 15.9523 2.42432 15.8595L3.01709 15.6064L0.958789 11.6617L0.141029 13.5762Z"
          fill="#74839C"
        />
        <path
          d="M3.64509 5.37299L2.99731 6.88976L6.85707 13.9659L10.6268 12.3557C8.02521 11.4299 4.56965 7.97997 3.64509 5.37299Z"
          fill="#74839C"
        />
        <path
          d="M10.1688 8.58152C9.98597 8.39841 9.98597 8.10155 10.1688 7.91844L11.3149 6.77258C10.7126 6.04619 9.98981 5.31733 9.22789 4.68552L8.08203 5.8317C7.90004 6.01372 7.60272 6.0155 7.41895 5.8317C7.23615 5.64859 7.23615 5.35173 7.41895 5.16862L8.48076 4.10712C7.45538 3.36955 5.56829 2.27037 4.66913 3.16875C3.63107 4.20712 5.14097 6.8032 7.16897 8.83151C8.74355 10.4061 10.6606 11.6682 11.9252 11.6682C12.2893 11.6682 12.5996 11.5635 12.8317 11.3313C13.7294 10.4329 12.6328 8.54768 11.8933 7.51972L10.8319 8.58152C10.6499 8.76351 10.3526 8.76529 10.1688 8.58152Z"
          fill="#74839C"
        />
        <path
          d="M9.64852 4.26493C10.4916 3.42186 10.6235 2.09007 9.96225 1.09795C9.51072 0.420807 8.67671 0.0983276 7.88676 0.295815C7.63584 0.358623 7.48304 0.612982 7.54585 0.864216C7.60866 1.11514 7.86301 1.26794 8.11425 1.20513C8.52047 1.10358 8.94982 1.2695 9.1823 1.61823C9.59634 2.23944 9.51385 3.07407 8.98575 3.60216L8.48079 4.10713C8.72858 4.28493 8.97857 4.47836 9.22793 4.68553L9.64852 4.26493Z"
          fill="#74839C"
        />
        <path
          d="M14.3822 6.81821C14.731 7.0507 14.8969 7.48005 14.7953 7.88627C14.7325 8.1375 14.8853 8.39186 15.1363 8.45467C15.3875 8.51748 15.6419 8.36499 15.7047 8.11376C15.9021 7.32381 15.5797 6.4898 14.9025 6.03826C13.9104 5.37706 12.5786 5.50892 11.7355 6.35199L11.3149 6.77259C11.5221 7.02195 11.7155 7.27193 11.8933 7.51973L12.3983 7.01476C12.9264 6.48667 13.761 6.40387 14.3822 6.81821Z"
          fill="#74839C"
        />
        <path
          d="M12.3316 4.33168L14.7065 1.95683C14.8895 1.77378 14.8895 1.47702 14.7065 1.29397C14.5235 1.11091 14.2267 1.11091 14.0436 1.29397L11.6688 3.66881C11.4857 3.85186 11.4857 4.14862 11.6688 4.33168C11.8518 4.51473 12.1486 4.51476 12.3316 4.33168Z"
          fill="#74839C"
        />
        <path
          d="M2.50095 1.71916H2.78218V2.00039C2.78218 2.25925 2.99204 2.46911 3.2509 2.46911C3.50976 2.46911 3.71962 2.25925 3.71962 2.00039V1.71916H4.00085C4.25971 1.71916 4.46957 1.5093 4.46957 1.25044C4.46957 0.99158 4.25971 0.781718 4.00085 0.781718H3.71962V0.469239C3.71962 0.21038 3.50976 0.000518799 3.2509 0.000518799C2.99204 0.000518799 2.78218 0.21038 2.78218 0.469239V0.781718H2.50095C2.24209 0.781718 2.03223 0.99158 2.03223 1.25044C2.03223 1.5093 2.24209 1.71916 2.50095 1.71916Z"
          fill="#74839C"
        />
        <path
          d="M15.5314 11.781H15.2189V11.4998C15.2189 11.2409 15.009 11.0311 14.7502 11.0311C14.4913 11.0311 14.2814 11.2409 14.2814 11.4998V11.781H14.0002C13.7414 11.781 13.5315 11.9909 13.5315 12.2497C13.5315 12.5086 13.7414 12.7185 14.0002 12.7185H14.2814V12.9997C14.2814 13.2585 14.4913 13.4684 14.7502 13.4684C15.009 13.4684 15.2189 13.2585 15.2189 12.9997V12.7185H15.5314C15.7902 12.7185 16.0001 12.5086 16.0001 12.2497C16.0001 11.9909 15.7903 11.781 15.5314 11.781Z"
          fill="#74839C"
        />
        <path
          d="M12.2509 0.937958C12.5097 0.937958 12.7196 0.728097 12.7196 0.469239C12.7196 0.21038 12.5097 0.000518799 12.2509 0.000518799C11.989 0.000518799 11.782 0.212911 11.782 0.469239C11.782 0.728097 11.992 0.937958 12.2509 0.937958Z"
          fill="#74839C"
        />
        <path
          d="M14.5317 4.25024C14.5317 4.5091 14.7418 4.71896 15.0006 4.71896C15.2595 4.71896 15.4693 4.5091 15.4693 4.25024C15.4693 3.99354 15.2617 3.78152 15.0003 3.78152C14.7414 3.78152 14.5317 3.99139 14.5317 4.25024Z"
          fill="#74839C"
        />
      </g>
      <defs>
        <clipPath id="clip0_252_422">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  
  const AuditoriumsIcon = () => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_252_453)">
        <path
          d="M14.0001 0.666656H2.00009C1.64647 0.666656 1.30733 0.807132 1.05729 1.05718C0.807237 1.30723 0.666761 1.64637 0.666761 1.99999V10.3333C0.666197 10.3977 0.684267 10.4608 0.718791 10.5151C0.753315 10.5694 0.802817 10.6125 0.861322 10.6393C0.919827 10.6661 0.984834 10.6754 1.0485 10.666C1.11216 10.6567 1.17176 10.6291 1.22009 10.5867C3.58009 8.55999 3.94009 5.03999 4.00009 3.99999C5.52633 3.69105 6.92187 2.9235 8.00009 1.79999C9.07832 2.9235 10.4739 3.69105 12.0001 3.99999C12.0534 5.06666 12.4068 8.58666 14.7734 10.6133C14.8231 10.6602 14.886 10.6907 14.9536 10.7007C15.0212 10.7106 15.0902 10.6996 15.1513 10.6691C15.2124 10.6385 15.2626 10.5899 15.2952 10.5299C15.3278 10.4698 15.3411 10.4012 15.3334 10.3333V1.99999C15.3334 1.64637 15.193 1.30723 14.9429 1.05718C14.6929 0.807132 14.3537 0.666656 14.0001 0.666656Z"
          fill="#74839C"
        />
        <path
          d="M3.33341 12.6667H2.00008C1.64646 12.6667 1.30732 12.8071 1.05727 13.0572C0.807224 13.3072 0.666748 13.6464 0.666748 14V15C0.666748 15.0884 0.701867 15.1732 0.764379 15.2357C0.826891 15.2982 0.911676 15.3333 1.00008 15.3333H4.33341C4.42182 15.3333 4.5066 15.2982 4.56912 15.2357C4.63163 15.1732 4.66675 15.0884 4.66675 15V14C4.66675 13.6464 4.52627 13.3072 4.27622 13.0572C4.02618 12.8071 3.68704 12.6667 3.33341 12.6667Z"
          fill="#74839C"
        />
        <path
          d="M8.66667 12.6667H7.33333C6.97971 12.6667 6.64057 12.8071 6.39052 13.0572C6.14048 13.3072 6 13.6464 6 14V15C6 15.0884 6.03512 15.1732 6.09763 15.2357C6.16014 15.2982 6.24493 15.3333 6.33333 15.3333H9.66667C9.75507 15.3333 9.83986 15.2982 9.90237 15.2357C9.96488 15.1732 10 15.0884 10 15V14C10 13.6464 9.85952 13.3072 9.60948 13.0572C9.35943 12.8071 9.02029 12.6667 8.66667 12.6667Z"
          fill="#74839C"
        />
        <path
          d="M14.0002 12.6667H12.6668C12.3132 12.6667 11.9741 12.8071 11.724 13.0572C11.474 13.3072 11.3335 13.6464 11.3335 14V15C11.3335 15.0884 11.3686 15.1732 11.4311 15.2357C11.4936 15.2982 11.5784 15.3333 11.6668 15.3333H15.0002C15.0886 15.3333 15.1734 15.2982 15.2359 15.2357C15.2984 15.1732 15.3335 15.0884 15.3335 15V14C15.3335 13.6464 15.193 13.3072 14.943 13.0572C14.6929 12.8071 14.3538 12.6667 14.0002 12.6667Z"
          fill="#74839C"
        />
        <path
          d="M9.00008 12C9.08849 12 9.17327 11.9649 9.23578 11.9024C9.2983 11.8399 9.33341 11.7551 9.33341 11.6667V11C9.33341 10.7348 9.22806 10.4804 9.04052 10.2929C8.85299 10.1054 8.59863 10 8.33341 10H7.66675C7.40153 10 7.14718 10.1054 6.95964 10.2929C6.7721 10.4804 6.66675 10.7348 6.66675 11V11.6667C6.66675 11.7551 6.70187 11.8399 6.76438 11.9024C6.82689 11.9649 6.91168 12 7.00008 12H9.00008Z"
          fill="#74839C"
        />
        <path
          d="M13.3334 11.6667V11C13.3334 10.7348 13.2281 10.4804 13.0405 10.2929C12.853 10.1054 12.5986 10 12.3334 10H11.6667C11.4015 10 11.1472 10.1054 10.9596 10.2929C10.7721 10.4804 10.6667 10.7348 10.6667 11V11.6667C10.6667 11.7551 10.7019 11.8399 10.7644 11.9024C10.8269 11.9649 10.9117 12 11.0001 12H13.0001C13.0885 12 13.1733 11.9649 13.2358 11.9024C13.2983 11.8399 13.3334 11.7551 13.3334 11.6667Z"
          fill="#74839C"
        />
        <path
          d="M4.33341 10H3.66675C3.40153 10 3.14718 10.1054 2.95964 10.2929C2.7721 10.4804 2.66675 10.7348 2.66675 11V11.6667C2.66675 11.7551 2.70187 11.8399 2.76438 11.9024C2.82689 11.9649 2.91168 12 3.00008 12H5.00008C5.08849 12 5.17327 11.9649 5.23578 11.9024C5.2983 11.8399 5.33341 11.7551 5.33341 11.6667V11C5.33341 10.7348 5.22806 10.4804 5.04052 10.2929C4.85299 10.1054 4.59863 10 4.33341 10Z"
          fill="#74839C"
        />
      </g>
      <defs>
        <clipPath id="clip0_252_453">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  const LeftArrowIcon = () => (
    <svg
      width={40}
      height={40}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.35355 11.6464C9.15829 11.8417 8.84171 11.8417 8.64645 11.6464L5.64645 8.64645C5.45118 8.45118 5.45118 8.13461 5.64645 7.93934L8.64645 4.93934C8.84171 4.74407 9.15829 4.74407 9.35355 4.93934C9.54882 5.13461 9.54882 5.45118 9.35355 5.64645L6.70711 8.29289L9.35355 10.9393C9.54882 11.1346 9.54882 11.4512 9.35355 11.6464Z"
        fill="#74839C"
      />
    </svg>
  );

  export {
    CalenderIcon,
    FavoriteIcon,
    ShareIcon,
    ScreenIcon,
    ParkingIcon,
    AirIcon,
    ProjectIcon,
    BanquetsIcon,
    PartyIcon,
    AuditoriumsIcon,
    LeftArrowIcon,
  };
  